import { Textarea } from '@mantine/core';

const AdjustableTextArea = ({ id, name, value, onChange, placeholder }) => {
  return (
    <Textarea
      onChange={onChange}
      id={id}
      name={name}
      value={value}
      placeholder={placeholder}
      autosize
      minRows={1}
      maxRows={15}
    />
  );
};

export default AdjustableTextArea;
